// Importeer de i18n-instantie direct
import i18n from '@/plugins/i18n'

export const currency = function(amount, decimalCount = 2) {
  try {
    // Controleer en converteer de input
    const value = Number(amount);
    if (isNaN(value)) {
      return amount;
    }
    
    // Bepaal de juiste locale op basis van de huidige taal
    const localeMap = {
      'nl': 'nl-NL',
      'en': 'en-GB',
      'de': 'de-DE',
      'fr': 'fr-FR'
    };
    
    // Gebruik de i18n-instantie die we geïmporteerd hebben
    const currentLocale = i18n.locale || 'nl';
    const formatterLocale = localeMap[currentLocale] || 'nl-NL';
    
    // Gebruik Intl.NumberFormat voor elegante formattering
    return new Intl.NumberFormat(formatterLocale, {
      minimumFractionDigits: decimalCount,
      maximumFractionDigits: decimalCount,
      useGrouping: true
    }).format(value);
  } catch (e) {
    console.log(e);
    return amount;
  }
}
